import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, NavItem } from 'reactstrap';
import classNames from 'classnames';
import Logout from '../button/logout'
import User from '../menu/user'
import {getProfilePicture} from '../../helpers/registrationHelper';

class NavMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMeasures: false,
      showMenu: false,
    };
    getProfilePicture()
      .then((data) => {
        let values = Object.assign({}, data.data);
        values.profile_picture = data.data.picture
        this.setState({ data: values })     
      }).catch((error) => {
        console.log(error)
      })
  }

  componentDidMount() {
    window.onclick = function (e) {
      if (e.target.matches && !e.target.matches('.dropdown')) {
        this.setState({
          showMeasures: false,
        })
      } else if (e.target.msMatchesSelector && !e.target.msMatchesSelector('.dropdown')) {
        this.setState({
          showMeasures: false,
        })
      }

    }.bind(this)
  }

  handleClick(e) {
    this.setState({
      showMenu: false,
    })

    e.target.parentElement.classList.toggle('open');
  }

  showMeasures(e) {
    e.preventDefault();
    let show = this.state.showMeasures;

    this.setState({
      showMeasures: !show,
    })
  }

  hamburgerMenuClicked() {
    let show = this.state.showMenu;

    this.setState({
      showMenu: !show,
    })
  }

  submenuClick(e) {
    e.preventDefault();
  }

  render() {

    var measuresClasses = classNames({
      'subMenu-wrapper': true,
      'show': this.state.showMeasures
    });

    return (
      <header className={this.state.showMenu ? "" : "close"}>
        <div className="page-container">
          <div>

            <div id="menuToggle">

              <input type="checkbox" checked={this.state.showMenu} onClick={this.hamburgerMenuClicked.bind(this)} />

              <span></span>
              <span></span>
              <span></span>

            </div>

            <User {...this.props} name={localStorage.getItem('name')} img={this.state.data ? this.state.data.profile_picture : "http://www.uni-regensburg.de/Fakultaeten/phil_Fak_II/Psychologie/Psy_II/beautycheck/english/durchschnittsgesichter/m(01-32)_gr.jpg"} />
          </div>
          <div className="menu-wrapper">
            <div className="logo-wrapper">
              <NavLink to={"/dashboard"} className={""} onClick={this.handleClick.bind(this)}>
                <div className="logo">WE CARE</div>
              </NavLink>
            </div>
            <Nav>
              <NavItem>
                <NavLink to={"/dashboard"} className={""} onClick={this.handleClick.bind(this)}>
                  <img src={require("../../images/Home.png")} alt="" />
                  <span>{"Home"}</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <a href="measures" className="dropdown" onClick={this.showMeasures.bind(this)}>
                  <img src={require("../../images/Measures.png")} alt="" />
                  Measures
                </a>
                <div className={measuresClasses}>
                  <div className="page-container">
                    <div className="submenu">
                      <NavLink to={"/measures/heart-rate"} onClick={this.handleClick.bind(this)}>
                        {"Heart Rate"}
                      </NavLink>
                      <NavLink to={"/measures/blood-pressure"} onClick={this.handleClick.bind(this)}>
                        {"Blood pressure"}
                      </NavLink>
                      <NavLink to={"/measures/breath-rate"} onClick={this.handleClick.bind(this)}>
                        {"Breath Rate"}
                      </NavLink>
                      <NavLink to={"/measures/ecg"} onClick={this.handleClick.bind(this)}>
                        {"ECG"}
                      </NavLink>
                      <NavLink to={"/measures/energy"} onClick={this.handleClick.bind(this)}>
                        {"Energy"}
                      </NavLink>
                      <NavLink to={"/measures/mood"} onClick={this.handleClick.bind(this)}>
                        {"Mood"}
                      </NavLink>
                      <NavLink to={"/measures/sleep"} onClick={this.handleClick.bind(this)}>
                        {"Sleep"}
                      </NavLink>
                      <NavLink to={"/measures/calories"} onClick={this.handleClick.bind(this)}>
                        {"Calories"}
                      </NavLink>
                      <a href="/" className="backBtn" onClick={this.submenuClick.bind(this)}>
                        <span>{"Back"}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </NavItem>
              <NavItem>
                <NavLink to={"/newsline"} className={""} onClick={this.handleClick.bind(this)}>
                  <img src={require("../../images/Newsline.png")} alt="" />
                  {"Newsline"}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to={"/network"} className={""} onClick={this.handleClick.bind(this)}>
                  <img src={require("../../images/Network.png")} alt="" />
                  {"Network"}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to={"/notifications"} className={""} onClick={this.handleClick.bind(this)}>
                  <img src={require("../../images/Notifications.png")} alt="" />
                  {"Notifications"}
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink to={"/messenger"} className={""} onClick={this.handleClick.bind(this)}>
                  <img src={require("../../images/Notifications.png")} alt="" />
                  {"Messenger"}
                </NavLink>
              </NavItem> */}
              <div className={this.state.showMeasures ? "hide" : ""}>
                <Logout {...this.props}/>
              </div>
            </Nav>
          </div>
        </div>
      </header>
    )

  }
}

export default NavMenu;


// WEBPACK FOOTER //
// ./src/components/menu/NavMenu.js